import sessionStorage from '@/utils/storage/sessionStorage';
const state = {
  isLoading: false,
  config: {},
  sessionInfo: null,
  currentCity: {},
  channelId: '',
  customId: '',
  breadcrumbItem: [],
  alone_custom: sessionStorage.get('alone_custom')
};

const getters = {
  currentCity: state => {
    return state.currentCity;
  }
};

const mutations = {
  setSessionInfo(state, session) {
    state.sessionInfo = session;
  },
  setConfig(state, config) {
    state.config = config;
  },
  setAlone(state, config) {
    state.alone_custom = config;
  },
  setChannelId(state, channelId) {
    state.channelId = channelId;
  },
  setCustomId(state, customId) {
    state.customId = customId;
  },
  updateLoadingStatus(state, payload) {
    state.isLoading = payload.isLoading;
  },
  showSidePanel(state) {
    state.panelStatus = true;
  },
  hideSidePanel(state) {
    state.panelStatus = false;
  },
  setCurrentCityInfo(state, city) {
    state.currentCity = city;
  },
  setBreadcrumbItem(state, action) {
    const { payload: breadcrumb, callback } = action;
    if (Array.isArray(breadcrumb)) {
      state.breadcrumbItem = breadcrumb;
      return;
    }
    const ignore = [
      '/',
      '/mall',
      '/movie',
      '/movie/film',
      '/movie/cinema',
      '/login',
      '/tour',
      '/lucky_wheel'
    ];
    if (ignore.includes(breadcrumb.path)) {
      state.breadcrumbItem = [];
    } else {
      let breadcrumbItems = [...state.breadcrumbItem];
      if (!breadcrumbItems.length) {
        breadcrumbItems = [
          {
            fullPath: '/mall?channel_id=10',
            meta: {
              title: '商城首页'
            }
          }
        ];
      }
      if (breadcrumbItems.length < 5) {
        const isExistedIndex = breadcrumbItems.findIndex(
          item => item.path === breadcrumb.path
        );
        if (isExistedIndex > 0) {
          breadcrumbItems.splice(isExistedIndex, 1);
        }
        state.breadcrumbItem = [...breadcrumbItems, breadcrumb];
      } else {
        const tmp = [...breadcrumbItems];
        tmp.splice(1, 1);
        state.breadcrumbItem = [...tmp, breadcrumb];
      }
      if (typeof callback === 'function') {
        callback(state.breadcrumbItem);
      }
    }
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
